import ApiClient from "../helpers/ApiClient";

const baseMensagemEndpoint = "/gestao/mensagens";

const getModelos = () =>
  ApiClient.apiClientDev.get(`${baseMensagemEndpoint}/modelos`);

const postModelo = (data) =>
  ApiClient.apiClientDev.post(`${baseMensagemEndpoint}/modelos`, data);

const getModelo = (uid) =>
  ApiClient.apiClientDev.get(`${baseMensagemEndpoint}/modelos/${uid}`);

const putModelo = (uid, data) =>
  ApiClient.apiClientDev.put(`${baseMensagemEndpoint}/modelos/${uid}`, data);

const deleteModelo = (uid) =>
  ApiClient.apiClientDev.delete(`${baseMensagemEndpoint}/modelos/${uid}`);

const getContatos = () =>
  ApiClient.apiClientDev.get(`${baseMensagemEndpoint}/contatos`);

const enviarMensagens = (data) =>
  ApiClient.apiClientDev.post(`${baseMensagemEndpoint}/enviar`, data);

const MensagensApiClient = {
  getModelos,
  postModelo,
  getModelo,
  putModelo,
  deleteModelo,
  getContatos,
  enviarMensagens,
};
export default MensagensApiClient;
